export default "__VITE_ASSET__DOqtLzEz__"